"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatDateDMY = exports.formatDateTime = exports.getDuplicateCars = exports.getOrdinal = exports.convertDateToUkTimeZoneDate = exports.convertDate = exports.convertDateTime = void 0;
exports.formatFileSize = formatFileSize;
exports.renderCoverStartDate = renderCoverStartDate;
exports.getIndexSetting = getIndexSetting;
exports.getNeverHigherPeriodAmount = getNeverHigherPeriodAmount;
exports.getNeverHigherPeriodWording = getNeverHigherPeriodWording;
exports.getVehicleTemporaryDrivers = getVehicleTemporaryDrivers;
exports.getVehiclePermanentDrivers = getVehiclePermanentDrivers;
exports.getVehicleRealMainDriverAndAdditionalDrivers = getVehicleRealMainDriverAndAdditionalDrivers;
exports.getRegisteredKeeper = getRegisteredKeeper;
exports.calculateValuablesTotalValue = calculateValuablesTotalValue;
exports.getAddressLines = getAddressLines;
exports.getAddressLine1WithPostcode = getAddressLine1WithPostcode;
exports.getAmountWithDecimalDigits = getAmountWithDecimalDigits;
exports.getAmountToDisplay = getAmountToDisplay;
exports.getSingleTierAmount = getSingleTierAmount;
exports.trimParenthesesFromString = trimParenthesesFromString;
exports.getValidationStyle = getValidationStyle;
exports.getHardDeclineEndDateText = getHardDeclineEndDateText;
exports.getCookieDomain = getCookieDomain;
exports.setCookie = setCookie;
exports.isPageValid = isPageValid;
exports.isCardExpired = isCardExpired;
exports.capitalize = capitalize;
exports.getFullAddressString = getFullAddressString;
exports.validatePhoneNumber = validatePhoneNumber;
exports.getInteractionVehicleFuelType = getInteractionVehicleFuelType;
exports.getVehicleEngineSize = getVehicleEngineSize;
exports.getVehicleNumberOfDoors = getVehicleNumberOfDoors;
exports.formatDate = formatDate;
exports.resolveClaimType = resolveClaimType;
exports.findMainAnnualPaymentCard = findMainAnnualPaymentCard;
exports.isMta = isMta;
exports.isCustomerPortalMtc = isCustomerPortalMtc;
exports.isRenewal = isRenewal;
exports.isCustomerPortalMta = isCustomerPortalMta;
exports.isSupportPortalMta = isSupportPortalMta;
exports.isSupportPortalMtc = isSupportPortalMtc;
exports.prepareQueryString = prepareQueryString;
exports.arraysIntersect = arraysIntersect;
exports.getWebChatScriptValueByPolicyNumber = getWebChatScriptValueByPolicyNumber;
exports.flattenObjectJson = flattenObjectJson;
exports.getDriverFieldsChangedCount = getDriverFieldsChangedCount;
exports.isAnnualProduct = isAnnualProduct;
exports.getCoverLimitAmount = getCoverLimitAmount;
exports.toHomeCoverLevel = toHomeCoverLevel;
exports.capitalizeFirstLetter = capitalizeFirstLetter;
exports.getAggregatorDisplayName = getAggregatorDisplayName;
exports.isBeforeIntroductionOfPersonalAccidentCover = isBeforeIntroductionOfPersonalAccidentCover;
exports.isBeforeIntroductionOfAllianzEssentialsTier = isBeforeIntroductionOfAllianzEssentialsTier;
exports.isBeforeIntroductionOfAllianzSilverTier = isBeforeIntroductionOfAllianzSilverTier;
exports.getInteractionPaymentAmount = getInteractionPaymentAmount;
exports.isUpfrontPrice = isUpfrontPrice;
exports.getTierChangeWording = getTierChangeWording;
exports.hasPriceForTier = hasPriceForTier;
exports.isPolicyHolderNameValid = isPolicyHolderNameValid;
exports.getCoverTierWording = getCoverTierWording;
exports.isTierNotDeclined = isTierNotDeclined;
exports.tierNotCalculatedOrNotDeclined = tierNotCalculatedOrNotDeclined;
exports.getEligibleTiers = getEligibleTiers;
exports.getHomeEligibleTiers = getHomeEligibleTiers;
exports.getRemainingSpreadAmount = getRemainingSpreadAmount;
exports.getUpfrontPaymentAmount = getUpfrontPaymentAmount;
exports.getHomeSelectedTierIconName = getHomeSelectedTierIconName;
exports.getHomeCoverTierWording = getHomeCoverTierWording;
exports.getCoverLevelWording = getCoverLevelWording;
exports.getValidationErrors = getValidationErrors;
exports.getMotorDOITitle = getMotorDOITitle;
exports.isCoverLevelContentsOnly = isCoverLevelContentsOnly;
exports.isCoverLevelBuildingsOnly = isCoverLevelBuildingsOnly;
exports.isCoverLevelBuildingsContents = isCoverLevelBuildingsContents;
exports.isPropertyOwned = isPropertyOwned;
exports.getPolicyStartDate = getPolicyStartDate;
exports.latestCoverChangeDate = latestCoverChangeDate;
var moment = require("moment-timezone");
var services_1 = require("@falcon/services");
var core_1 = require("@athena-portal/core");
var DocumentListModal_1 = require("./widgets/annual/motor/DocumentListModal");
var DATETIME_FORMAT = "DD MMM YYYY, HH:mm";
var convertDateTime = function (inputDate) {
    return (0, exports.convertDate)(inputDate, DATETIME_FORMAT);
};
exports.convertDateTime = convertDateTime;
var convertDate = function (inputDate, format) {
    var valueAsMoment = moment.utc(inputDate, moment.ISO_8601);
    if (valueAsMoment.isValid()) {
        return (valueAsMoment.format(format));
    }
    return null;
};
exports.convertDate = convertDate;
function formatFileSize(byteSize) {
    var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    if (byteSize === 0) {
        return '';
    }
    var kilobyteSize = parseInt(String(Math.floor(Math.log(byteSize) / Math.log(1024))), 10);
    return Math.round(byteSize / Math.pow(1024, kilobyteSize)) + ' ' + sizes[kilobyteSize];
}
function renderCoverStartDate(startDate) {
    var format = DATETIME_FORMAT;
    if (moment(startDate).isSame(moment(), 'day')) {
        return (0, exports.convertDateToUkTimeZoneDate)(startDate, format);
    }
    else {
        // This is a workaround for the fact that startDate coming from database is 23:59 UTC and it needs to stay as 23:59
        // This explains why in one case startDate is rendered in UK time and in the other case as UTC
        return (0, exports.convertDate)(startDate, format);
    }
}
var convertDateToUkTimeZoneDate = function (inputDate, format) {
    var valueAsMoment = moment.utc(inputDate, moment.ISO_8601);
    if (valueAsMoment.isValid()) {
        return valueAsMoment.tz("Europe/London").format(format);
    }
    return null;
};
exports.convertDateToUkTimeZoneDate = convertDateToUkTimeZoneDate;
var getOrdinal = function (value) {
    var suffixes = ["th", "st", "nd", "rd"];
    var numberEnding = value % 100;
    return value + (suffixes[(numberEnding - 20) % 10] || suffixes[numberEnding] || suffixes[0]);
};
exports.getOrdinal = getOrdinal;
//
// Compares quote vehicles with active subscription ones and returns duplicates
//
var getDuplicateCars = function (quoteVehicles, policyVehiclesRegistrationNumbers) {
    var duplicateVehicles = [];
    if (!quoteVehicles || !policyVehiclesRegistrationNumbers) {
        return duplicateVehicles;
    }
    policyVehiclesRegistrationNumbers.forEach(function (policyVehicleRegistrationNumber) {
        var value = quoteVehicles.find(function (quoteVehicle) { return quoteVehicle.registrationNumber === policyVehicleRegistrationNumber; });
        if (value) {
            duplicateVehicles.push(value);
        }
    });
    return duplicateVehicles;
};
exports.getDuplicateCars = getDuplicateCars;
function getIndexSetting(setting, index, questionType) {
    if (index) {
        if (isNaN(index)) {
            throw Error("".concat(questionType, " widget has incorrectly set '").concat(setting, "' setting: '").concat(setting, "' must be a number"));
        }
        else if (index < 0) {
            throw Error("".concat(questionType, " widget has incorrectly set '").concat(setting, "' setting: '").concat(setting, "' must be a non-negative integer"));
        }
    }
    else if (!index && index !== 0) {
        throw Error("".concat(questionType, " widget missing 'index' setting"));
    }
    return index;
}
// Retrieves never higher amount for different scenarios
function getNeverHigherPeriodAmount(interaction) {
    // if mtaChangeAddress Quote
    if (interaction.process === services_1.INTERACTION_PROCESS_CHANGE_ADDRESS ||
        interaction.process === services_1.INTERACTION_PROCESS_MTA_CHANGE_POLICY_HOLDER_DETAILS ||
        interaction.process === services_1.INTERACTION_PROCESS_MTA_REINSTATE_SUBSCRIPTION) {
        return interaction.factors.neverHigher;
    }
    else {
        return interaction.uistate.subscriptionNeverHigher;
    }
}
// Retrieves never higher amount period wording
function getNeverHigherPeriodWording(interaction, subscriptionNeverHigher, policies) {
    var constraintEndDate = null;
    if (services_1.productHelper.includesMotorProduct(policies) && interaction.vehicles) {
        constraintEndDate = (0, exports.convertDate)(interaction.vehicles[0].factors.constraintEndDate, "DD MMMM YYYY");
    }
    else if (services_1.productHelper.includesRentersProduct(policies) && interaction.realEstates) {
        constraintEndDate = (0, exports.convertDate)(interaction.realEstates[0].realEstateFactors.constraintEndDate, "DD MMMM YYYY");
    }
    return (constraintEndDate) ?
        "".concat(getAmountToDisplay(subscriptionNeverHigher), " per month until ").concat(constraintEndDate, ", based on your current details") :
        "".concat(getAmountToDisplay(subscriptionNeverHigher), " for next 3 months, based on your current details");
}
function getVehicleTemporaryDrivers(vehicle, temporaryDrivers) {
    var vehicleTempDrivers = [];
    if (vehicle.driverIds && vehicle.driverIds.length !== 0 && temporaryDrivers && temporaryDrivers.length !== 0) {
        vehicle.driverIds.forEach(function (driverId) {
            var tempDriver = temporaryDrivers.find(function (driver) { return driverId === driver.personId; });
            if (tempDriver) {
                vehicleTempDrivers.push(tempDriver);
            }
        });
    }
    return vehicleTempDrivers;
}
function getVehiclePermanentDrivers(vehicle, permanentDrivers) {
    var vehiclePermanentDrivers = [];
    if (vehicle.driverIds && vehicle.driverIds.length !== 0 && permanentDrivers && permanentDrivers.length !== 0) {
        vehicle.driverIds.forEach(function (driverId) {
            var permanentDriver = permanentDrivers.find(function (driver) { return driverId === driver.personId; });
            if (permanentDriver) {
                vehiclePermanentDrivers.push(permanentDriver);
            }
        });
    }
    return vehiclePermanentDrivers;
}
function getVehicleRealMainDriverAndAdditionalDrivers(drivers, mainDriverId) {
    var mainDriver;
    var additionalDrivers = [];
    drivers.forEach(function (driver) {
        if (driver.personId === mainDriverId) {
            mainDriver = driver;
        }
        else {
            additionalDrivers.push(driver);
        }
    });
    return { mainDriver: mainDriver, additionalDrivers: additionalDrivers };
}
function getRegisteredKeeper(interaction, carIndex) {
    var vehicle = interaction.vehicles[carIndex];
    var allDrivers = [interaction.policyHolder].concat(interaction.additionalDrivers || []);
    var registeredKeeper = "";
    vehicle.driverIds.forEach(function (driverId) {
        var foundDriver = allDrivers.find(function (driver) { return driver.personId && (driverId === driver.personId) && (driver.personId === vehicle.registeredKeeperId); });
        if (foundDriver) {
            registeredKeeper = "".concat(foundDriver.firstName, " ").concat(foundDriver.lastName);
        }
        else {
            return;
        }
    });
    return registeredKeeper;
}
function calculateValuablesTotalValue(valuableItems) {
    return valuableItems.map(function (item) { return item.value; }).reduce(function (total, next) { return Number(total) + Number(next); }, 0);
}
function getAddressLines(address) {
    var addressComponents = getFullAddressString(address, false).split(", ");
    var convertedComponents = [];
    for (var _i = 0, _a = addressComponents.slice(0, -1); _i < _a.length; _i++) {
        var component = _a[_i];
        var addressLine = [];
        for (var _b = 0, _c = component.split(' '); _b < _c.length; _b++) {
            var separateWord = _c[_b];
            addressLine.push(separateWord.charAt(0).toUpperCase() + separateWord.slice(1).toLowerCase());
        }
        convertedComponents.push(addressLine.join(" "));
    }
    // Postcode line should have all letter in uppercase, so it is not being converted
    convertedComponents.push(addressComponents[addressComponents.length - 1]);
    return convertedComponents;
}
function getAddressLine1WithPostcode(address) {
    var addressLines = getAddressLines(address);
    var shortenedAddress = [];
    shortenedAddress.push(addressLines[0]);
    shortenedAddress.push(addressLines[addressLines.length - 1]);
    return shortenedAddress.join(", ");
}
function getAmountWithDecimalDigits(amount) {
    var fixedAmount = 1 * amount;
    return new Intl.NumberFormat('en-UK', { style: 'currency', currency: 'GBP' }).format(fixedAmount);
}
function getAmountToDisplay(amount) {
    if ((amount % 1) === 0) {
        return "£" + new Intl.NumberFormat('en-UK').format(amount);
    }
    else {
        return getAmountWithDecimalDigits(amount);
    }
}
function getSingleTierAmount(tier1Amount, tier2Amount, tier3Amount, tier) {
    if (tier === services_1.BRONZE_TIER) {
        return getAmountToDisplay(tier1Amount);
    }
    if (tier === services_1.SILVER_TIER) {
        return getAmountToDisplay(tier2Amount);
    }
    if (tier === services_1.GOLD_TIER) {
        return getAmountToDisplay(tier3Amount);
    }
    return "";
}
function trimParenthesesFromString(name) {
    return name.replace(/[()]/g, '');
}
function getValidationStyle(isValid) {
    if (isValid) {
        return "is-valid";
    }
    if (isValid === undefined) {
        return "";
    }
    return "is-invalid";
}
function getHardDeclineEndDateText(interaction) {
    var weekLater = moment().utc().add(7, "d");
    var currentEndDate = moment(interaction.headerInfo.endDate, moment.ISO_8601).utc();
    var today = moment().utc();
    var agreementStartDate = moment(interaction.headerInfo.startDate, moment.ISO_8601).utc();
    var declineEndDate;
    if (today.isBefore(agreementStartDate)) {
        declineEndDate = agreementStartDate.format("DD MMMM YYYY");
    }
    else {
        declineEndDate = currentEndDate.isSameOrBefore(weekLater)
            ? currentEndDate.format("DD MMMM YYYY") : weekLater.format("DD MMMM YYYY");
    }
    return " on " + declineEndDate;
}
function getCookieDomain(hostname) {
    var topLevelDomainsToCheck = [".com", ".co.uk"];
    for (var _i = 0, topLevelDomainsToCheck_1 = topLevelDomainsToCheck; _i < topLevelDomainsToCheck_1.length; _i++) {
        var tld = topLevelDomainsToCheck_1[_i];
        if (hostname.endsWith(tld)) {
            var hostnameWithoutTld = hostname.replace(new RegExp("".concat(tld, "$")), "");
            var subdomainsAndDomain = hostnameWithoutTld.split(".");
            var domain = subdomainsAndDomain[subdomainsAndDomain.length - 1];
            return domain + tld;
        }
    }
    return hostname;
}
function setCookie(name, value, millis) {
    var expires = "";
    var domain = "; domain=".concat(getCookieDomain(window.location.hostname));
    if (millis) {
        var date = new Date();
        date.setTime(date.getTime() + millis);
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + domain + "; path=/";
}
function isPageValid(pageValidations, validations) {
    if (pageValidations) {
        for (var _i = 0, pageValidations_1 = pageValidations; _i < pageValidations_1.length; _i++) {
            var validation = pageValidations_1[_i];
            if (validation.valid === false && validation.errorMessage) {
                return false;
            }
        }
    }
    if (validations) {
        for (var _a = 0, _b = Object.keys(validations); _a < _b.length; _a++) {
            var questionName = _b[_a];
            var validationResult = validations[questionName];
            if (validationResult.errors && validationResult.errors.length > 0) {
                return false;
            }
        }
    }
    return true;
}
function isCardExpired(card) {
    var dateNow = new Date();
    return card.expiryYear < (dateNow.getFullYear() % 100) || (card.expiryYear === (dateNow.getFullYear() % 100) && card.expiryMonth < (dateNow.getMonth() + 1));
}
function capitalize(text) {
    return text.toLowerCase().split(' ').map(function (s) { return s.charAt(0).toUpperCase() + s.substring(1).toLowerCase(); }).join(' ');
}
function getFullAddressString(addressDetails, shouldCapitalize) {
    if (shouldCapitalize === void 0) { shouldCapitalize = true; }
    var fullAddressString;
    if (addressDetails.fullAddress) {
        fullAddressString = addressDetails.fullAddress;
    }
    else {
        var subBuildingName = addressDetails.subBuildingName ? addressDetails.subBuildingName : "";
        var buildingName = addressDetails.buildingName ? addressDetails.buildingName : "";
        var buildingNumber = addressDetails.buildingNumber ? addressDetails.buildingNumber.toString() : "";
        var thoroughfareName = addressDetails.thoroughfareName ? addressDetails.thoroughfareName : "";
        var thoroughfareDescriptor = addressDetails.thoroughfareDescriptor ? addressDetails.thoroughfareDescriptor : "";
        var dependentThoroughfareName = addressDetails.dependentThoroughfareName ? addressDetails.dependentThoroughfareName : "";
        var dependentThoroughfareDescriptor = addressDetails.dependentThoroughfareDescriptor ? addressDetails.dependentThoroughfareDescriptor : "";
        var dependentLocality = addressDetails.dependentLocality ? addressDetails.dependentLocality : "";
        var doubleDependentLocality = addressDetails.doubleDependentLocality ? addressDetails.doubleDependentLocality : "";
        var postCode = addressDetails.postcode ? addressDetails.postcode : "";
        var addressLine1 = [subBuildingName, buildingName].filter(function (e) { return e.length !== 0; }).join(' ');
        var addressLine2 = [buildingNumber, dependentThoroughfareName, dependentThoroughfareDescriptor, thoroughfareName, thoroughfareDescriptor].filter(function (e) { return e.length !== 0; }).join(' ');
        var addressLine3 = [doubleDependentLocality, dependentLocality].filter(function (e) { return e.length !== 0; }).join(' ');
        var addressLine4 = addressDetails.postTown ? addressDetails.postTown : "";
        fullAddressString = [addressLine1, addressLine2, addressLine3, addressLine4, postCode].filter(function (e) { return e.length !== 0; }).join(', ');
    }
    return shouldCapitalize ? capitalize(fullAddressString) : fullAddressString;
}
function validatePhoneNumber(phoneNumber) {
    var invalidPhoneRegex = /^[0][0-1]{9,10}$/;
    if (invalidPhoneRegex.test(phoneNumber)) {
        return false;
    }
    var phoneRegex = /^[0][0-9]{9,10}$/;
    return phoneRegex.test(phoneNumber);
}
function getInteractionVehicleFuelType(fuelCode, fuelTypeFull) {
    if (fuelTypeFull && fuelTypeFull.includes('/')) {
        return 'H';
    }
    else {
        return fuelCode;
    }
}
function getVehicleEngineSize(vehicle) {
    if (vehicle.engineSize) {
        return vehicle.engineSize;
    }
    else if (vehicle.lvVehicleData && vehicle.lvVehicleData.engineSizeCc) {
        return vehicle.lvVehicleData.engineSizeCc; // leaving field from vehicle data for old quotes and subscriptions
    }
    else {
        return "";
    }
}
function getVehicleNumberOfDoors(vehicle) {
    if (vehicle.doors) {
        return vehicle.doors;
    }
    else if (vehicle.lvVehicleData && vehicle.lvVehicleData.numberOfDoors) {
        return vehicle.lvVehicleData.numberOfDoors; // leaving field from vehicle data for old quotes and subscriptions
    }
    else {
        return "";
    }
}
function formatDate(inputDate, format) {
    var valueAsMoment = moment.utc(inputDate, moment.ISO_8601);
    if (valueAsMoment.isValid()) {
        return (valueAsMoment.format(format));
    }
    return "";
}
function resolveClaimType(claimTypeId) {
    var claimType = {
        "1": "Accident - you hit somebody/something",
        "2": "Accident - you/somebody hit each other",
        "3": "Accident - somebody/something hit you",
        "4": "Windscreen/Window glass",
        "5": "Malicious damage/Vandalism",
        "6": "Theft of vehicle",
        "7": "Theft from vehicle",
        "8": "Fire",
        "9": "Storm/Flood/Weather damage"
    };
    return claimType[claimTypeId];
}
function findMainAnnualPaymentCard(party, mainCardId) {
    for (var _i = 0, _a = party.paymentCards; _i < _a.length; _i++) {
        var card = _a[_i];
        if (Number(mainCardId) === card.id) {
            return card;
        }
    }
    return null;
}
/**
 * Checks if the process is any kind of MTA
 *
 * @param process
 * @returns Returns true if the process is any kind of MTA otherwise false
 */
function isMta(process) {
    return process.startsWith("mta");
}
function isCustomerPortalMtc(process) {
    return process.startsWith("mtc");
}
/**
 * Checks if the process is any kind of renewal
 *
 * @param process
 * @returns Returns true if the process is any kind of renewal otherwise false
 */
function isRenewal(process) {
    return process.startsWith("renewal");
}
/**
 * Checks if the process is an MTA from the Customer Portal
 *
 * @param process
 * @returns Returns true if the process is an MTA from the Customer Portal otherwise false
 */
function isCustomerPortalMta(process) {
    return isMta(process) && !isSupportPortalMta(process);
}
/**
 * Checks if the process is an MTA from the Support Portal
 *
 * @param process
 * @returns Returns true if the process is an MTA from the Support Portal otherwise false
 */
function isSupportPortalMta(process) {
    return process.startsWith("mtaSupportPortal");
}
/**
 * Checks if the process is an MTC from the Support Portal
 *
 * @param process
 * @returns Returns true if the process is an MTC from the Support Portal otherwise false
 */
function isSupportPortalMtc(process) {
    return process != null && process.startsWith("supportPortalAnnualCancellation");
}
/**
 * Creates query string from config string
 *
 * @param queryStringConfig Config string with values separated by `;`
 * @returns Returns query string with params from config string
 */
function prepareQueryString(queryStringConfig) {
    var queryMap = core_1.ConfigHelper.parseMapFromString(queryStringConfig);
    return core_1.ConfigHelper.mapToQueryString(queryMap);
}
/**
 * Determines if there is any intersection between two arrays.
 *
 * @param array1 - The first array to check for intersection.
 * @param array2 - The second array to check for intersection.
 * @returns Returns `true` if there is at least one common element between the arrays, otherwise `false`.
 */
function arraysIntersect(array1, array2) {
    if (!array1 || !array2) {
        return false;
    }
    var set1 = new Set(array1);
    var commonItems = array2.filter(function (item) { return set1.has(item); });
    return commonItems.length > 0;
}
function getWebChatScriptValueByPolicyNumber(policyNumber) {
    if (services_1.POLICY_NUMBER_PREFIX_MAP.HOME.some(function (prefix) { return policyNumber.startsWith(prefix); })) {
        return "home";
    }
    if (services_1.POLICY_NUMBER_PREFIX_MAP.WOLF_MOTOR.some(function (prefix) { return policyNumber.startsWith(prefix); })) {
        return "motor";
    }
    return undefined;
}
function flattenObjectJson(objectPerson) {
    var target = {};
    flatObject(objectPerson, target);
    return target;
}
function flatObject(source, target) {
    Object.keys(source).forEach(function (k) {
        if (Array.isArray(source[k])) {
            source[k].forEach(function iter(a) {
                if (Array.isArray(a)) {
                    a.forEach(iter);
                    return;
                }
                if (a !== null && typeof a === 'object') {
                    flatObject(a, target);
                }
            });
            return;
        }
        if (source[k] !== null && typeof source[k] === 'object') {
            flatObject(source[k], target);
            return;
        }
        target[k] = source[k];
    });
}
function getDriverFieldsChangedCount(interactionPersons, policyInteractionPersons) {
    var difference = Object.keys(interactionPersons).filter(function (key) {
        if (key === "numberOfReadOnlyClaims" || key === "numberOfReadOnlyConviction" || key === "driverInfoEdited") {
            return;
        }
        else {
            var bothNullOrUndefined = (interactionPersons[key] === null || interactionPersons[key] === undefined) && (policyInteractionPersons[key] === null || policyInteractionPersons[key] === undefined);
            var diff = interactionPersons[key] !== policyInteractionPersons[key];
            return diff && !bothNullOrUndefined;
        }
    });
    return difference.length;
}
var formatDateTime = function (inputDate) {
    return formatDate(inputDate, "D MMMM YYYY, HH:mm");
};
exports.formatDateTime = formatDateTime;
var formatDateDMY = function (inputDate) {
    return formatDate(inputDate, "D MMMM YYYY");
};
exports.formatDateDMY = formatDateDMY;
function isAnnualProduct(product) {
    return product === services_1.PRODUCT_WOLF_MOTOR || product === services_1.PRODUCT_ANNUAL_HOME;
}
function getCoverLimitAmount(type, amountType, interaction) {
    var limit = interaction.covers.filter(function (cover) { return cover.type === type; })[0].amounts.filter(function (amount) { return amount.type === amountType; })[0];
    return limit ? limit.amount : 0;
}
function toHomeCoverLevel(covers) {
    var cover = covers.filter(function (cover) { return Object.values(services_1.HomeCoverLevelEnum).includes(cover.type); })[0];
    return cover.type;
}
function capitalizeFirstLetter(text) {
    var trimmedText = text.trim();
    return trimmedText.charAt(0).toUpperCase() + trimmedText.slice(1);
}
function getAggregatorDisplayName(referrerAggregator) {
    var source;
    switch (referrerAggregator) {
        case "ctm":
        case "ctmhome":
            source = "CompareTheMarket.com";
            break;
        case "cnf":
        case "cnfhome":
            source = "Confused.com";
            break;
        case "gc":
        case "gchome":
            source = "Gocompare.com";
            break;
        case "msm":
        case "msmhome":
            source = "MoneySuperMarket.com";
            break;
        case "elx":
            source = "ElectriX";
            break;
        default:
            source = "aggregator";
            console.error("Unrecognized referrer aggregator '".concat(referrerAggregator, "'"));
            break;
    }
    return source;
}
function isBeforeIntroductionOfPersonalAccidentCover(date) {
    return date && moment(date).isBefore(process.env.REACT_APP_ESSENTIALS_PERSONAL_ACCIDENT_COVER_RELEASE_DATE);
}
function isBeforeIntroductionOfAllianzEssentialsTier(date) {
    return date && moment(date).isBefore(process.env.REACT_APP_ALLIANZ_ESSENTIALS_TIER_RELEASE_DATE);
}
function isBeforeIntroductionOfAllianzSilverTier(date) {
    return date && moment(date).isBefore(process.env.REACT_APP_ALLIANZ_SILVER_TIER_RELEASE_DATE);
}
function getInteractionPaymentAmount(interaction, isUpfrontInterest, debtCombined) {
    var process = interaction.process;
    var factors = interaction.factors;
    if (process === "mtaPayOffBalance") {
        return factors.payOffPremium;
    }
    else if (isRenewal(process)) {
        return factors.annualPremium;
    }
    else if (debtCombined && !isCustomerPortalMtc(process)) {
        return factors.mtaAndDebtCombinedAdditionalAmount;
    }
    else if (isCustomerPortalMta(process) || isCustomerPortalMtc(process)) {
        var annualHasDebt = factors.premiumType === services_1.PREMIUM_TYPE_ANNUAL
            && factors.debtAmount
            && factors.debtAmount !== 0;
        if (isUpfrontInterest) {
            // Usually upfront interest correction payment matches upfront payment, but there
            // can be cases where upfront interest correction is only part of the upfront payment
            return factors.upfrontPaymentAmount;
        }
        else if (isCustomerPortalMtc(process) && annualHasDebt) {
            return factors.additionalPremium;
        }
        return (isUpfrontPrice(interaction, annualHasDebt)) ? factors.upfrontPaymentAmount : factors.additionalPremium;
    }
    else {
        // If execution ever enters here, then we have some process which is not implemented in this method yet, i.e. Support Portal
        return 0;
    }
}
function isUpfrontPrice(interaction, annualHasDebt) {
    var factors = interaction.factors;
    return (interaction.uistate
        && !interaction.uistate.payFullPrice
        && services_1.productHelper.isHomeOrWolfMotor(interaction)
        && factors.premiumType !== services_1.PREMIUM_TYPE_ANNUAL ||
        annualHasDebt);
}
function getTierChangeWording(interaction) {
    var newTier = interaction === null || interaction === void 0 ? void 0 : interaction.coverTier;
    var previousTier = interaction === null || interaction === void 0 ? void 0 : interaction.uistate.previousCoverTier;
    if (!previousTier || newTier === previousTier) {
        return "";
    }
    switch (newTier) {
        case services_1.MOTOR_COVER_TIERS.MOTOR_TIER_3:
            return "and upgrade to our Allianz cover, our highest level of comprehensive insurance.";
        case services_1.MOTOR_COVER_TIERS.MOTOR_TIER_2:
            if (previousTier !== services_1.MOTOR_COVER_TIERS.MOTOR_TIER_3) {
                return "and upgrade to Allianz Silver.";
            }
            else {
                return "and change your cover level to Allianz Silver.";
            }
        case services_1.MOTOR_COVER_TIERS.MOTOR_TIER_1:
            return "and change your cover level to Allianz Essentials.";
        default:
            return "";
    }
}
function hasPriceForTier(oldTier, currentCoverTier, tieredFactors) {
    var _a;
    var premiumForTierExists = (_a = tieredFactors === null || tieredFactors === void 0 ? void 0 : tieredFactors.some(function (factor) { return (factor === null || factor === void 0 ? void 0 : factor.tier) === oldTier; })) !== null && _a !== void 0 ? _a : false;
    return (oldTier === currentCoverTier || premiumForTierExists);
}
function isPolicyHolderNameValid(policyHolderName) {
    var expression = /^[a-z ,.'-]+$/i;
    return expression.test(policyHolderName.firstName) && expression.test(policyHolderName.lastName);
}
function getCoverTierWording(coverTier) {
    switch (coverTier) {
        case services_1.MOTOR_COVER_TIERS.MOTOR_TIER_1:
            return services_1.resourcesHelper.PRODUCT_TIER_1;
        case services_1.MOTOR_COVER_TIERS.MOTOR_TIER_2:
            return services_1.resourcesHelper.PRODUCT_TIER_2;
        default:
            return services_1.resourcesHelper.PRODUCT_TIER_3;
    }
}
function isTierNotDeclined(tier, tieredUnderwritingResult) {
    var tierNotDeclined = tieredUnderwritingResult.some(function (UWResult) { return UWResult.tier === tier && UWResult.underwritingFailures.length === 0; });
    return tierNotDeclined;
}
function tierNotCalculatedOrNotDeclined(tier, tieredUnderwritingResult) {
    if (!tieredUnderwritingResult.some(function (res) { return res.tier === tier; })) {
        return true;
    }
    else {
        return isTierNotDeclined(tier, tieredUnderwritingResult);
    }
}
function getEligibleTiers(interaction) {
    var eligibleTiers = [services_1.MOTOR_COVER_TIERS.MOTOR_TIER_1, services_1.MOTOR_COVER_TIERS.MOTOR_TIER_2, services_1.MOTOR_COVER_TIERS.MOTOR_TIER_3];
    if (!interaction.tieredUnderwritingResult) {
        if (!interaction.underwritingResult || interaction.underwritingResult.length === 0) {
            return [services_1.MOTOR_COVER_TIERS.MOTOR_TIER_3];
        }
        else {
            return [];
        }
    }
    return eligibleTiers.filter(function (tier) {
        return tierNotCalculatedOrNotDeclined(tier, interaction.tieredUnderwritingResult);
    });
}
function getHomeEligibleTiers(interaction) {
    var eligibleTiers = [services_1.BRONZE_TIER, services_1.SILVER_TIER, services_1.GOLD_TIER];
    if (!interaction.tieredUnderwritingResult) {
        if (!interaction.underwritingResult || interaction.underwritingResult.length === 0) {
            return [services_1.GOLD_TIER];
        }
        else {
            return [];
        }
    }
    return eligibleTiers.filter(function (tier) {
        return tierNotCalculatedOrNotDeclined(tier, interaction.tieredUnderwritingResult);
    });
}
function getRemainingSpreadAmount(factors) {
    if (factors.monthlyPaymentSpreadWithInterestAmount) {
        return getAmountToDisplay(factors.monthlyPaymentSpreadWithInterestAmount) + " (including interest)";
    }
    else if (factors.monthlyPaymentSpreadAmount > 0) {
        return getAmountToDisplay(factors.monthlyPaymentSpreadAmount);
    }
    else {
        return "";
    }
}
function getUpfrontPaymentAmount(factors) {
    if (factors.upfrontPaymentAmount > 0) {
        return getAmountToDisplay(factors.upfrontPaymentAmount);
    }
    else {
        return "";
    }
}
function getHomeSelectedTierIconName(coverTier) {
    switch (coverTier) {
        case services_1.HomeCoverTier.BRONZE:
            return "AZ-Bronze";
        case services_1.HomeCoverTier.SILVER:
            return "AZ-Silver";
        case services_1.HomeCoverTier.GOLD:
            return "AZ-Gold";
        default:
            return "";
    }
}
function getHomeCoverTierWording(coverTier) {
    switch (coverTier) {
        case services_1.HomeCoverTier.BRONZE:
            return services_1.resourcesHelper.PRODUCT_TIER_1;
        case services_1.HomeCoverTier.SILVER:
            return services_1.resourcesHelper.PRODUCT_TIER_2;
        default:
            return services_1.resourcesHelper.PRODUCT_TIER_3;
    }
}
function getCoverLevelWording(coverLevel) {
    var coverLevels = {
        BUILDINGS_CONTENTS: "Buildings and Contents",
        BUILDINGS: "Buildings",
        CONTENTS: "Contents"
    };
    return coverLevels[coverLevel];
}
function getValidationErrors(props, name) {
    var _a, _b, _c, _d, _e, _f;
    var errors = (_b = (_a = props.validations[name]) === null || _a === void 0 ? void 0 : _a.errors) !== null && _b !== void 0 ? _b : [];
    var questions = (_d = (_c = props.page) === null || _c === void 0 ? void 0 : _c.questions) !== null && _d !== void 0 ? _d : [];
    var validationError = [];
    for (var _i = 0, questions_1 = questions; _i < questions_1.length; _i++) {
        var question = questions_1[_i];
        if (question.interactionField !== undefined) {
            if (question.name === name) {
                validationError = (_f = (_e = question.validations) === null || _e === void 0 ? void 0 : _e.filter(function (validation) { var _a; return errors.includes((_a = validation.errorMessage) !== null && _a !== void 0 ? _a : ""); })) !== null && _f !== void 0 ? _f : [];
                return validationError;
            }
        }
    }
    return validationError;
}
function getMotorDOITitle(documentVersion) {
    if (services_1.resourcesHelper.THEME === "Britannia") {
        return "Britannia Car Insurance Policy Booklet";
    }
    else {
        var isAllianzOnlineDoc = (0, DocumentListModal_1.getDocumentVersionNumberOnly)(documentVersion) >= (0, DocumentListModal_1.getDocumentVersionNumberOnly)(DocumentListModal_1.DocVersionEnum.V9);
        return isAllianzOnlineDoc ? "Allianz Online Car Insurance Document of Insurance" : "Allianz Car Document of Insurance (DOI)";
    }
}
function isCoverLevelContentsOnly(coverLevel) {
    return coverLevel === services_1.HomeCoverLevelEnum.CONTENTS;
}
function isCoverLevelBuildingsOnly(coverLevel) {
    return coverLevel === services_1.HomeCoverLevelEnum.BUILDINGS;
}
function isCoverLevelBuildingsContents(coverLevel) {
    return coverLevel === services_1.HomeCoverLevelEnum.BUILDINGS_CONTENTS;
}
function isPropertyOwned(ownershipType) {
    return ownershipType === services_1.HomeOwnershipType.OWNED_OUTRIGHT || ownershipType === services_1.HomeOwnershipType.OWNED_MORTGAGED;
}
function getPolicyStartDate(factors) {
    return (factors === null || factors === void 0 ? void 0 : factors.renewalQuoteDate)
        ? new Date(factors === null || factors === void 0 ? void 0 : factors.renewalQuoteDate) : new Date(factors === null || factors === void 0 ? void 0 : factors.originalQuoteDate);
}
function latestCoverChangeDate(coverChanges, covers) {
    // Returns certain cover latest modification date if it was added
    covers = Array.isArray(covers) ? covers : [covers];
    var latestCover = coverChanges
        .filter(function (coverChange) { return covers.includes(coverChange === null || coverChange === void 0 ? void 0 : coverChange.changedField); })
        .sort(function (a, b) { return b.startDate.localeCompare(a.startDate) ||
        Number(a.action === "REMOVED") - Number(b.action === "REMOVED"); })[0];
    return (latestCover === null || latestCover === void 0 ? void 0 : latestCover.action) === "ADDED" ? new Date(latestCover.startDate) : undefined;
}
//# sourceMappingURL=commonFunctions.js.map